<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left">
          <h2 class="text-purple-manax m-0 pl-3 title-section"><b>Solicitudes</b></h2>
        </span>
        <span class="pull-right pt-1 pb-4">
          <button mat-raised-button type="button" class="btn btn-manax p-2 mr-1" (click)="openAgent()">
            <i class="material-icons">badge</i>&nbsp;<span class="d-none d-sm-inline">Agentes</span>
          </button>

        </span>
        <br><br>
        <table class="table table-hover m-0 align-top" stickyHeader matSort (matSortChange)="sortTasks($event)">

          <thead class="text-manax pb-1">
            <tr>

              <!-- PC -->
              <!-- <th class="d-none d-md-table-cell p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th> -->

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;">
                Agente<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.agent"
                  placeholder="Buscar por Agente…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 250px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;">
                Cliente<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.client"
                  placeholder="Buscar por Cliente…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 250px;" />
              </th>
              <!-- <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;">
                Intrucciones<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.client"
                  placeholder="Buscar por Cliente…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th> -->
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;">
                Teléfono<br>
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;">
                Email<br>
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                mat-sort-header="createdAt">
                Solicitado el<br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.createdAt"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 120px;  position: absolute; top: 27px; left: 0px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative; max-width: 1000px;">
                Estado<br>
                <select class="filter small" [(ngModel)]="filter.filters.status" (ngModelChange)="lazySearch()"
                  (click)="$event.stopPropagation()" style="max-width: 1000px;">
                  <option [ngValue]="''"></option>
                  <option *ngFor="let key of taskRequestStatusesKeys" [ngValue]="key">{{taskRequestStatuses[key]}}
                  </option>
                </select>
              </th>

              <!-- <th class="d-none d-md-table-cell align-top" width="1%"
                style="height: 65px; position: relative; max-width: 1000px;" mat-sort-header="isDeleted">
                Estado<br>
                <select class="filter small" [(ngModel)]="filter.filters.isDeleted" (ngModelChange)="lazySearch()"
                  (click)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 27px; left: 0px;">
                  <option [ngValue]="false"> activo </option> //isDeleted: false 
                  <option [ngValue]="true"> inactivo </option> //isDeleted: true 
                  <option [ngValue]="undefined"> todos </option>
                </select>
              </th> -->

              <!-- Mobile -->

              <!-- PC -->
              <th class="d-none d-md-table-cell td-actions text-right p-0">
                <!-- <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>
                </mat-menu>  -->
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let taskRequest of taskRequests" [class.text-danger]="taskRequest?.isDeleted"
              class='cursor-pointer' (click)="openTasksRequestDetailModal(taskRequest)">

              <!-- All -->
              <!-- <td class="d-none d-md-table-cell p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(agent._id)"
                      [checked]="selection.all || selection[agent._id]">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td> -->

              <!-- PC -->
              <td class="d-none d-md-table-cell">{{taskRequest?.agent?.name || '- enlace público -'}}</td>
              <td class="d-none d-md-table-cell"><b class="bold-item">{{taskRequest.client?.firstname}}
                  {{taskRequest.client?.lastname}}</b></td>
              <!-- <td class="d-none d-md-table-cell"><span class="truncate-text">{{ taskRequest?.description }}</span></td> -->
              <td class="d-none d-md-table-cell">{{taskRequest.client?.phone}}</td>
              <td class="d-none d-md-table-cell">{{taskRequest.client?.email}}</td>
              <td class="d-none d-md-table-cell">{{taskRequest?.createdAt | date:'dd/MM/yyyy' }}</td>
              <td class="d-none d-md-table-cell">
                <div class="text-center"
                  style="border-radius: 15px; font-weight: 600; padding: 5px 20px; color: white; font-size: 13px;"
                  [ngStyle]="{'background-color': taskRequestStatusesColor[taskRequest?.status || ''] || 'PENDING'}">
                  {{taskRequestStatusesLabel[taskRequest?.status || ''] || 'Pendiente'}}
                </div>
              </td>
              <!-- <td class="d-none d-md-table-cell">
                <span *ngIf="!agent.isDeleted">activo</span>
                <span *ngIf="agent.isDeleted">inactivo</span>
              </td> -->

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="col-12">
                  <div class="row">
                    <div class="col-8">
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">Agente:</b>&nbsp;{{taskRequest?.agent?.name || '- enlace público -'}}
                      </div>
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">Cliente:</b>&nbsp;
                        {{taskRequest?.client?.firstname}} {{taskRequest?.client?.lastname ?
                        taskRequest?.client?.lastname :
                        ''}}
                      </div>
                      <div class="row mb-2 pr-3" *ngIf="taskRequest?.title">
                        <b class="bold-item">Asunto:</b>&nbsp;{{taskRequest?.title}}
                      </div>
                      <div class="row mb-2 pr-3" *ngIf="taskRequest?.client?.phone">
                        <b class="bold-item">Teléfono:</b>&nbsp;{{taskRequest?.client?.phone}}
                      </div>
                      <div class="row pr-3" *ngIf="taskRequest?.client?.phone">
                        <b class="bold-item">Email:</b>&nbsp;{{taskRequest?.client?.email}}
                      </div>
                    </div>
                    <div class="col-4 d-flex align-items-center justify-content-center">
                      <div class="row mb-2">
                        <div class="text-center"
                          style="border-radius: 15px; font-weight: 600; padding: 5px 20px; color: white; font-size: 13px;"
                          [ngStyle]="{'background-color': taskRequestStatusesColor[taskRequest?.status || ''] || 'PENDING'}">
                          {{taskRequestStatusesLabel[taskRequest?.status || ''] || 'Pendiente'}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <!-- <button mat-menu-item (click)="openDeleteTaskRequestConfirm(taskRequest, true)" *ngIf="isDev">
                    <span>Hard Delete</span>
                  </button> -->
                  <!-- <button mat-menu-item (click)="openDeleteTaskRequestConfirm(taskRequest)"
                    *ngIf="!taskRequest?.isDeleted">
                    <span>Eliminar</span>
                  </button>
                  <button mat-menu-item (click)="openRestoreTaskRequestConfirm(taskRequest)"
                    *ngIf="taskRequest?.isDeleted">
                    <span>Restaurar</span>
                  </button> -->
                  <button mat-menu-item (click)="openTasksRequestDetailModal(taskRequest)"
                    *ngIf="!taskRequest?.isDeleted">
                    <span>Abrir</span>
                  </button>
                  <button mat-menu-item (click)="openTaskRequestClient(taskRequest)" *ngIf="!taskRequest?.isDeleted">
                    <span>Aceptar</span>
                  </button>
                  <button mat-menu-item (click)="openRejectedTaskRequestConfirm(taskRequest)"
                    *ngIf="!taskRequest?.isDeleted">
                    <span>Rechazar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All  -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax" *ngIf="!loading">
            <tr>
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ taskRequests.length }} solicitudes</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

  </div>
</div>